module.exports = __webpack_public_path__ + "img/76348.05e72b52.svg";